import ButtonComp from "themes/elements/Button";
import { isPermit } from "utils/permissionCheck";

function NonApprovalButtons(props) {
  const { onEdit, setDlt, selectedNews, tabActive } = props;

  return (
    <>
      {isPermit(3, "delete") && (
        <ButtonComp variant="secondary" onClick={() => setDlt(true)}>
          Delete
        </ButtonComp>
      )}
    </>
  );
}

export default NonApprovalButtons;
